import { gql } from "@apollo/client";

export const GET_AI_SETTINGS = gql`
  query GetAISettings {
    spaceliftIntelligenceTermsAccepted
    spaceliftIntelligenceEnabled
    spaceliftIntelligenceTermsLatestVersion {
      content
      version
    }
    infraAssistantEnabled
    infraAssistantBuildModeEnabled
  }
`;

export const SET_SPACELIFT_INTELLIGENCE_ENABLED = gql`
  mutation SetSpaceliftIntelligenceEnabled($enabled: Boolean!) {
    accountSetSpaceliftIntelligenceEnabled(enabled: $enabled)
  }
`;

export const SET_INFRA_ASSISTANT_ENABLED = gql`
  mutation SetInfraAssistantEnabled($enabled: Boolean!) {
    accountSetInfraAssistantEnabled(enabled: $enabled)
  }
`;

export const SET_INFRA_ASSISTANT_BUILD_MODE_ENABLED = gql`
  mutation SetInfraAssistantBuildModeEnabled($enabled: Boolean!) {
    accountSetInfraAssistantBuildModeEnabled(enabled: $enabled)
  }
`;

export const REQUEST_INFRA_ASSISTANT_ENABLING = gql`
  mutation RequestInfraAssistantEnabling {
    accountRequestInfraAssistantEnabling
  }
`;
